import { render } from "./AddPlaceholder.vue?vue&type=template&id=6e20be52"
import script from "./AddPlaceholder.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./AddPlaceholder.vue?vue&type=script&charset=utf-8&lang=js"

import "./AddPlaceholder.vue?vue&type=style&index=0&id=6e20be52&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__